/**
 * ****************************************************************************
 * @description     :   Route for bs app
 * @created at      :   2022/02/20
 * @created by      :   ANS874 – quanhvm@ans-asia.com
 * @package         :   Best Security
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import component of view
 */
const bf001000l = () => import('@/views/bf/bf001000l');
const bf002000l = () => import('@/views/bf/bf002000l');
const bf006000l = () => import('@/views/bf/bf006000l');
const bf005000u = () => import('@/views/bf/bf005000u');
const bf004000l = () => import('@/views/bf/bf004000l');
const bf003000u = () => import('@/views/bf/bf003000u');
const bf007000u = () => import('@/views/bf/bf007000u');

/**
 * Defined Router
 */
export default [
    {
        path: '/bf/bf001000l',
        name: 'Bf001000l',
        component: bf001000l,
        meta: {
            title: '出勤簿管理一覧',
            layout: 'MainLayout'
        }
    },
    {
        path: '/bf/bf002000l',
        name: 'Bf002000l',
        component: bf002000l,
        meta: {
            title: '隊員別勤怠売上集計一覧',
            layout: 'MainLayout'
        }
    },
    {
        path: '/bf/bf006000l',
        name: 'Bf006000l',
        component: bf006000l,
        meta: {
            title: '隊員別勤怠集計ファイル出力',
            layout: 'MainLayout'
        }
    },
    {
        path: '/bf/bf005000u',
        name: 'Bf005000u',
        component: bf005000u,
        meta: {
            title: '勤怠集計取消',
            layout: 'MainLayout'
        }
    },
    {
        path: '/bf/bf004000l',
        name: 'Bf004000l',
        component: bf004000l,
        meta: {
            title: '隊員別勤務集計一覧',
            layout: 'MainLayout'
        }
    },
    {
        path: '/bf/bf003000u',
        name: 'Bf003000u',
        component: bf003000u,
        meta: {
            title: '勤怠集計処理',
            layout: 'MainLayout'
        }
    },
    {
        path: '/bf/bf007000u',
        name: 'Bf007000u',
        component: bf007000u,
        meta: {
            title: '給与ソフトから隊員マスタのインポート',
            layout: 'MainLayout'
        }
    }
];
